<template>
  <div class="home">
    <CostList v-show="listView" @newCost="onClickNewFromList" @editCost="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <CostForm v-show="formView" :cost="cost" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import CostList from '@/components/cost/CostList.vue'
import CostForm from '@/components/cost/CostForm.vue'

export default {
  name: 'Cost',
  components: {
    CostList,
    CostForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      cost: {
        id: null,
        cost_no: null,
        type_id: null,
        type: {
          id: null,
          name: null
        },
        category_id: null,
        category: {
          id: null,
          name: null
        },
        bank_id: null,
        bank: {
          id: null,
          group_id: null,
          name: null,
          account_no: null,
          address: null,
          phone: null,
          email: null
        },
        ref_no: null,
        description: null,
        method: null,
        cash_date: null,
        amount: null,
        amount_in: null,
        amount_out: null,
        notes: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null
        },
        branch_no: null,
        branch: {
          id: null,
          branch_no: null,
          org_id: null,
          name: null,
          address: null,
          phone: null,
          email: null
        },
        vendor: null,
        purchasing: null,
        sales: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.cost = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.cost = {
        id: null,
        cost_no: null,
        type_id: null,
        type: {
          id: null,
          name: null
        },
        category_id: null,
        category: {
          id: null,
          name: null
        },
        bank_id: null,
        bank: {
          id: null,
          group_id: null,
          name: null,
          account_no: null,
          address: null,
          phone: null,
          email: null
        },
        ref_no: null,
        description: null,
        method: null,
        cash_date: date,
        amount: null,
        amount_in: null,
        amount_out: null,
        notes: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null
        },
        branch_no: null,
        branch: {
          id: null,
          branch_no: null,
          org_id: null,
          name: null,
          address: null,
          phone: null,
          email: null
        },
        vendor: null,
        purchasing: null,
        sales: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.cost = {
        id: null,
        cost_no: null,
        type_id: null,
        type: {
          id: null,
          name: null
        },
        category_id: null,
        category: {
          id: null,
          name: null
        },
        bank_id: null,
        bank: {
          id: null,
          group_id: null,
          name: null,
          account_no: null,
          address: null,
          phone: null,
          email: null
        },
        ref_no: null,
        description: null,
        method: null,
        cash_date: null,
        amount: null,
        amount_in: null,
        amount_out: null,
        notes: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null
        },
        branch_no: null,
        branch: {
          id: null,
          branch_no: null,
          org_id: null,
          name: null,
          address: null,
          phone: null,
          email: null
        },
        vendor: null,
        purchasing: null,
        sales: null
      }
      this.$refs.refreshList.refreshCost()
      // this.$router.replace({ path: 'sales', query: null })
    }
  },
  mounted () {
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getCostTypeList')
    this.$store.dispatch('getCostCategoryList')
    this.$store.dispatch('getBankList')
  }
}
</script>
